import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
} from "reactstrap";
import { helper } from 'lib/helper';
import AuthModel from "models/auth.model";
import { useState } from "react";


const Login = () => {


  const [data, setData] = useState({ email: '', password: '' });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setData({ ...data, [name]: value });
  };



  const handleSubmit = async (e) => {
    e.preventDefault();


    if(data.email === '' || data.password === '') return;

    try {
      const res = await AuthModel.login(data)
      if (res) {
        sessionStorage.setItem("access_token", res.data.token);
        sessionStorage.setItem("userinfo", JSON.stringify(res.data.data));
        console.log(res.data);
        sessionStorage.setItem('type' , res.data.type)
        window.location.assign("/admin/index");
      }
    } catch (error) {
      helper.sweetalert.toast(error.response?.data?.error, "warning")
    }

    // const formData = new FormData(e.target);
    // if (e.target.email.value != "" && e.target.password.value != "") {
    //   await AuthModel.login(formData).then((res) => {
    //     if (res) {
    //       sessionStorage.setItem("access_token", res.data.token);
    //       sessionStorage.setItem("userinfo", JSON.stringify(res.data.id));
          
    //       window.location.assign("/admin/index");
    //     }
    //     // console.log(res)
    //   }).catch((error) => {
    //     helper.sweetalert.toast(error.response?.data?.error, "warning")
    //   })
    // }
    // console.log(e.target.email.value);
  }

  return (
    <>
      <Col lg="5" md="7">
        <Card className="bg-secondary shadow border-0">

          <CardBody className="px-lg-5 py-lg-5">
            <div className="text-center text-muted mb-4">
              <small>Sign in with credentials</small>
            </div>
            <Form role="form" onSubmit={handleSubmit}>
              <FormGroup className="mb-3">
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-email-83" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Email"
                    type="text"
                    name="email"
                    autoComplete="new-email"
                    required
                   value={data.email}
                   onChange={handleChange}
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-lock-circle-open" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Password"
                    type="password"
                    name="password"
                    autoComplete="new-password"
                    required
                    value={data.password}
                    onChange={handleChange}
                  />
                </InputGroup>
              </FormGroup>

              <div className="text-center">
                <Button className="my-4" color="primary" type="submit">
                  Sign in
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>

      </Col>
    </>
  );
};

export default Login;
